export const locale = {
    lang: 'fr',
    data: {
        EXPORT_BOARD: 'Exporter vers un tableau',
        EXPORT: 'Exporter',
        SAVE: 'Annuler',
    }
};
